<template>
  <div class="sales-label" :class="{'amount-scale':config.card_tag=='amount'}">
    <!-- 产品卡片 折扣标签金额文本 -->
    <div 
      v-if="config.card_tag=='amount'" 
      class="sales-label--text"
      :class="{'no-image-sales-label': !config.sale_image}"
    >
      <p class="sales-label--text-save">{{ $t('ProductCard.salesLabel.SAVE')}}</p>
      <p class="sales-label--text-price">
        <v-selectprice
          :price="price.agio"
          :font-size="16"
          :disable_select="true"
          :country="$store.state.pricetype"
          :show_country="false"
        ></v-selectprice>
      </p>
    </div>
    <!-- 产品卡片 折扣标签百分比文本 -->
    <div 
      v-else 
      class="sales-label--text"
      :class="{'no-image-sales-label': !config.sale_image}"
      :style="{minWidth: '66px'}"
    >
      <p class="sales-label--text-save" style="order: 2">{{ $t('ProductCard.salesLabel.OFF') }}</p>
      <p class="sales-label--text-price">{{ price.percentage }}%</p>
    </div>
    <!-- 产品卡片 折扣标签图片 -->
    <div class="sales-label--image"  v-if="config.sale_image">
      <img :src="config.sale_image" :class="{'amount-image':config.card_tag=='amount'}" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props:{
    //当前产品的金额
    price:{
      type: Object,
      default: null
    },
    //产品卡片配置
    config: {
      type: Object,
      default: null
    }
  },
  data(){
    return {
      tagIamgeScale: 0, //图片的宽高比
    }
  },
  mounted(){
    this.$el.style.setProperty('--tag-label-color', this.config.card_tag_text_color ? this.config.card_tag_text_color :'#FFFFFF')
    if(this.config.sale_image){
      let img = new Image()
      img.src = this.config.sale_image
      img.onload = ()=>{
        this.tagIamgeScale = (img.width / img.height).toFixed(3)
        if(this.config.card_tag =='discount'){
          if(this.tagIamgeScale > 1 ){
            this.$el.style.setProperty('--tag-label-width', (66 * this.tagIamgeScale) + 'px')
          }else{
            this.$el.style.setProperty('--tag-label-width', 66 + 'px')
          }
        }else{
          this.getTagLabelWidth()
        }
      }
    }
  },
  methods: {
    getTagLabelWidth(){
      let widthScale = this.tagIamgeScale * 80
      let textWidth = this.$el.children[0].clientWidth
      this.$el.style.setProperty('--tag-label-width', (textWidth > widthScale ? textWidth : widthScale) + 'px')
    }
  },
  watch:{
    'price.agio'(){
      if(this.config.card_tag =='amount' && this.config.sale_image){
        this.$nextTick(()=>{
          this.getTagLabelWidth()
        })
      }
    },
    '$store.state.pricetype'(){
      if(this.config.card_tag =='amount' && this.config.sale_image){
        this.$nextTick(()=>{
          this.getTagLabelWidth()
        })
      }
    }
  }
}
</script>

<style scoped lang='scss'>
#app {
  .sales-label {
    width: var(--tag-label-width);
    position: absolute;
    display: flex;
    justify-content: center;
    flex-direction: column;
    top: 0;
    right: 0;
    z-index: 1;
    align-items: center;
    color: var(--tag-label-color);
    transform: scale(0.9);
    transform-origin: right top;
    margin: 1%;
    .no-image-sales-label {
      position: initial;
    }
    &--text {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: max-content;
      position: absolute;
      margin: auto 0;
      margin-top: 3px;
    }
    &--text-save {
      font-size: 12px;
      font-weight: 600;
      font-style: normal;
      line-height: 1;
    }
    &--text-price {
      font-size: 18px;
      font-weight: 600;
      font-style: normal;
      line-height: 1;
      padding: 0 8px;
      &::v-deep {
        .selectpricewrap {
          .price_text {
            color: var(--tag-label-color) !important ;
          }
        }
      }
    }
    &--image {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
        min-width: 66px;
        min-height: 66px;
      }
      .amount-image{
        height: 80px;
        min-width: 0px;
      }
    }
  }
  .amount-scale {
    transform: scale(0.8);
  }


  @media screen and(max-width: 768px) {
    .sales-label {
      transform: scale(0.6);
    }
  }
}
</style>
